<template>
  <div class="tools">
    <div class="layout layout1">
      <div class="l">
        <h2 class="h2 mortina">{{ langTxt[lang].index.hashTalk[0] }}</h2>
        <p>{{ langTxt[lang].index.hashTalk[1] }}</p>
        <div class="btn_box">
          <a :href="imDownloadUrl" class="onlypc">
            <ui_botton_3 @click="reportRefereeUser" class="xbd"
              ><span class="win"
                ><svg
                  width="105"
                  height="18"
                  viewBox="0 0 105 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.09 2.148H30.304L32.806 12.156H32.878L35.506 2.148H37.558L40.186 12.156H40.258L42.76 2.148H44.974L41.266 15H39.178L36.568 5.082H36.496L33.886 15H31.78L28.09 2.148ZM47.4984 1.968C47.8944 1.968 48.2124 2.088 48.4524 2.328C48.7044 2.556 48.8304 2.862 48.8304 3.246C48.8304 3.606 48.6984 3.918 48.4344 4.182C48.1704 4.422 47.8584 4.542 47.4984 4.542C47.1384 4.542 46.8264 4.422 46.5624 4.182C46.3104 3.93 46.1844 3.618 46.1844 3.246C46.1844 2.862 46.3104 2.556 46.5624 2.328C46.8024 2.088 47.1144 1.968 47.4984 1.968ZM46.5444 5.694H48.4524V15H46.5444V5.694ZM55.7511 5.442C58.0671 5.442 59.2251 6.714 59.2251 9.258V15H57.3171V9.42C57.3171 7.836 56.5911 7.044 55.1391 7.044C54.5751 7.044 54.1011 7.236 53.7171 7.62C53.2731 8.064 53.0151 8.658 52.9431 9.402V15H51.0351V5.694H52.9431V6.846C53.2911 6.39 53.7051 6.042 54.1851 5.802C54.6291 5.562 55.1511 5.442 55.7511 5.442ZM68.1022 1.896H70.0102V15H68.2282V13.884C67.5682 14.796 66.6082 15.252 65.3482 15.252C63.9802 15.252 62.9062 14.766 62.1262 13.794C61.4062 12.894 61.0462 11.73 61.0462 10.302C61.0462 8.922 61.4002 7.788 62.1082 6.9C62.8642 5.928 63.9142 5.442 65.2582 5.442C66.3982 5.442 67.3462 5.988 68.1022 7.08V1.896ZM65.6902 6.99C64.7422 6.99 64.0462 7.308 63.6022 7.944C63.2062 8.484 63.0082 9.27 63.0082 10.302C63.0082 11.334 63.1942 12.132 63.5662 12.696C63.9982 13.368 64.6882 13.704 65.6362 13.704C66.4402 13.704 67.0822 13.374 67.5622 12.714C67.9582 12.114 68.1562 11.352 68.1562 10.428V10.266C68.1562 9.27 67.9162 8.46 67.4362 7.836C66.9802 7.272 66.3982 6.99 65.6902 6.99ZM76.448 5.442C77.864 5.442 78.992 5.91 79.832 6.846C80.672 7.782 81.092 8.952 81.092 10.356C81.092 11.772 80.678 12.93 79.85 13.83C78.974 14.778 77.84 15.252 76.448 15.252C75.056 15.252 73.922 14.778 73.046 13.83C72.218 12.93 71.804 11.772 71.804 10.356C71.804 8.928 72.224 7.758 73.064 6.846C73.916 5.91 75.044 5.442 76.448 5.442ZM76.448 7.008C75.56 7.008 74.876 7.356 74.396 8.052C73.976 8.628 73.766 9.396 73.766 10.356C73.766 11.304 73.976 12.066 74.396 12.642C74.888 13.338 75.572 13.686 76.448 13.686C77.312 13.686 78.002 13.338 78.518 12.642C78.95 12.03 79.166 11.268 79.166 10.356C79.166 9.408 78.95 8.64 78.518 8.052C78.014 7.356 77.324 7.008 76.448 7.008ZM81.9142 5.694H84.0202L85.9822 12.732L87.8902 5.694H89.6542L91.5622 12.732L93.5242 5.694H95.6302L92.4802 15H90.7162L88.7722 8.034L86.8282 15H85.0642L81.9142 5.694ZM100.283 5.442C102.707 5.442 104.027 6.42 104.243 8.376H102.389C102.245 7.872 102.023 7.524 101.723 7.332C101.399 7.116 100.907 7.008 100.247 7.008C99.6465 7.008 99.2145 7.092 98.9505 7.26C98.6145 7.44 98.4465 7.716 98.4465 8.088C98.4465 8.4 98.6985 8.676 99.2025 8.916C99.5145 9.048 100.139 9.234 101.075 9.474C102.119 9.726 102.905 10.02 103.433 10.356C104.177 10.824 104.549 11.472 104.549 12.3C104.549 14.268 103.169 15.252 100.409 15.252C97.8645 15.252 96.4845 14.166 96.2685 11.994H98.1405C98.2485 12.618 98.4705 13.062 98.8065 13.326C99.1425 13.566 99.6585 13.686 100.355 13.686C101.843 13.686 102.587 13.266 102.587 12.426C102.587 11.97 102.311 11.616 101.759 11.364C101.471 11.22 100.847 11.04 99.8865 10.824C98.7825 10.572 98.0145 10.302 97.5825 10.014C96.8625 9.558 96.5025 8.934 96.5025 8.142C96.5025 7.29 96.8505 6.63 97.5465 6.162C98.2425 5.682 99.1545 5.442 100.283 5.442Z"
                    fill="white"
                  />
                  <path
                    d="M18 8.55V0C14.7094 0.45 11.4469 0.9 8.15625 1.43437V8.63438L18 8.55ZM0 2.64375V8.69063C2.41875 8.69063 4.89375 8.6625 7.3125 8.6625V1.63125C4.89375 1.96875 2.41875 2.27812 0 2.64375ZM0 9.39375V15.4406C2.41875 15.7781 4.89375 16.0875 7.3125 16.425V9.42188C4.89375 9.42188 2.41875 9.39375 0 9.39375ZM8.2125 9.53438C8.24063 11.8969 8.24062 14.2594 8.24062 16.6219C11.5031 17.0719 14.7375 17.5219 18 18V9.53438H8.2125Z"
                    fill="white"
                  />
                </svg> </span
            ></ui_botton_3>
          </a>
          <a :href="imDownloadUrl_mac" class="onlypc">
            <ui_botton_3
              @click="reportRefereeUser"
              class="xbd"
              :drak="'drak'"
              :disclick="true"
              ><span class="mac"
                ><svg
                  width="61"
                  height="18"
                  viewBox="0 0 61 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.26 4.148H28.582L33.064 14.444H33.118L37.582 4.148H39.904V17H37.942V7.82H37.87L33.928 17H32.236L28.294 7.82H28.222V17H26.26V4.148ZM46.4459 7.442C47.8139 7.442 48.8219 7.784 49.4699 8.468C50.0339 9.068 50.3159 9.932 50.3159 11.06V17H48.5519V15.686C48.2039 16.142 47.7479 16.52 47.1839 16.82C46.5719 17.108 45.8579 17.252 45.0419 17.252C44.0819 17.252 43.3199 17.006 42.7559 16.514C42.1799 16.01 41.8919 15.344 41.8919 14.516C41.8919 13.34 42.3539 12.47 43.2779 11.906C44.0579 11.426 45.0779 11.186 46.3379 11.186L48.4259 11.168V10.934C48.4259 9.638 47.7239 8.99 46.3199 8.99C45.6599 8.99 45.1559 9.11 44.8079 9.35C44.3879 9.626 44.1419 10.034 44.0699 10.574H42.1799C42.3239 9.47 42.7919 8.654 43.5839 8.126C44.2559 7.67 45.2099 7.442 46.4459 7.442ZM48.4259 12.626L46.4639 12.644C44.7239 12.644 43.8539 13.25 43.8539 14.462C43.8539 14.834 43.9919 15.14 44.2679 15.38C44.5439 15.62 44.9459 15.74 45.4739 15.74C46.3259 15.74 47.0399 15.5 47.6159 15.02C48.1559 14.528 48.4259 13.892 48.4259 13.112V12.626ZM56.6399 7.442C57.8279 7.442 58.7819 7.712 59.5019 8.252C60.2339 8.84 60.6899 9.704 60.8699 10.844H58.9799C58.8479 10.196 58.5899 9.734 58.2059 9.458C57.8219 9.158 57.2999 9.008 56.6399 9.008C55.8479 9.008 55.2299 9.302 54.7859 9.89C54.3299 10.454 54.1019 11.27 54.1019 12.338C54.1019 13.394 54.3239 14.216 54.7679 14.804C55.1879 15.392 55.8059 15.686 56.6219 15.686C58.0379 15.686 58.8359 14.978 59.0159 13.562H60.9059C60.6899 14.798 60.2159 15.728 59.4839 16.352C58.7519 16.952 57.7919 17.252 56.6039 17.252C55.1879 17.252 54.0839 16.784 53.2919 15.848C52.5239 14.96 52.1399 13.796 52.1399 12.356C52.1399 10.952 52.5179 9.8 53.2739 8.9C54.0899 7.928 55.2119 7.442 56.6399 7.442Z"
                    fill="white"
                  />
                  <path
                    d="M12.5064 9.59832C12.5064 11.173 13.5332 12.5978 15 13.1977C14.7066 14.0975 14.2666 14.9974 13.7532 15.7472C13.0198 16.872 12.213 17.9219 10.9662 17.9219C9.71934 17.9968 9.27929 17.247 7.88578 17.247C6.49227 17.247 6.05221 17.9219 4.87873 17.9968C3.70525 18.0718 2.7518 16.7971 1.94503 15.7472C0.331499 13.4976 -0.841981 9.44834 0.771554 6.67383C1.57832 5.32407 3.04517 4.42422 4.58536 4.42422C5.75884 4.42422 6.93232 5.17409 7.59241 5.17409C8.25249 5.17409 9.71934 4.19926 11.1862 4.34924C12.5064 4.42422 13.7532 5.02412 14.5599 6.14892C13.3131 6.8238 12.5797 8.17356 12.5064 9.59832ZM7.51906 4.12428C7.44572 3.07446 7.81243 2.09963 8.47252 1.34976C9.20594 0.599895 10.1594 0.0749868 11.1862 0C11.2595 1.04982 10.8928 2.09963 10.2327 2.8495C9.57266 3.74934 8.54586 4.19926 7.51906 4.12428Z"
                    fill="white"
                  />
                </svg> </span
            ></ui_botton_3>
          </a>
        </div>
      </div>
      <div class="r">
        <img class="ui" :src="cdnUrl + '/web_assets/img/tools_im.png'" alt="" />
        <img class="ico plane" :src="cdnUrl + '/web_assets/img/tools_plane.png'" alt="" />
      </div>
    </div>
    <div class="layout layout2">
      <div class="l">
        <div class="rocket_box">
          <img :src="cdnUrl + '/web_assets/img/tools_rocket_bg.png'" alt="" class="ico" />
          <img :src="cdnUrl + '/web_assets/img/tools_rocket.png'" alt="" class="rocket" />
        </div>
      </div>
      <div class="r">
        <h2 class="h2 mortina">{{ langTxt[lang].index.vpn[0] }}</h2>
        <p>{{ langTxt[lang].index.vpn[1] }}</p>
        <ui_botton_1 :width="'1.86rem'" class="onlypc" @click="toVpnPage">{{
          langTxt[lang].index.vpn[2]
        }}</ui_botton_1>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tools {
  width: 100%;
  max-width: 19.2rem;
  margin: 0 auto;
  color: #fff;
  background: url("https://cdn.blockwar.io/web_assets/img/tools_vpn.png") no-repeat right
    bottom / 9.57rem auto;
}

.layout {
  display: flex;
  justify-content: center;
  align-items: stretch;

  h2 {
    font-size: 0.32rem;
    margin-top: 3rem;
  }

  p {
    font-size: 0.18rem;
    line-height: 0.28rem;
  }
}

.layout1 {
  height: 7.59rem;

  .l {
    width: 3.7rem;
    margin-right: 0.9rem;
    margin-left: 0.1rem;

    .btn_box {
      display: flex;

      .btn3 {
        margin-right: 0.2rem;

        .win {
          display: flex;
          width: 1.06rem;
        }

        .mac {
          display: flex;
          width: 0.62rem;
        }
      }
    }
  }

  .r {
    width: 8.35rem;
    position: relative;

    .ui {
      width: 100%;
      position: absolute;
      bottom: 0;
    }

    .ico {
      width: 2.23rem;
      position: absolute;
      top: 1.2rem;
      right: 0;
    }
  }
}

.layout2 {
  width: 10.17rem;
  height: 10.34rem;
  overflow: hidden;

  .l {
    width: 5.32rem;
    position: relative;
    margin-right: 1.59rem;

    .rocket_box {
      width: 5.32rem;
      height: auto;
      position: absolute;
      left: 0;
      top: 2.77rem;

      .ico {
        width: 100%;
      }

      .rocket {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .r {
    width: 3.6rem;

    h2 {
      margin-top: 4.9rem;
    }
  }
}

.plane {
  animation: flyToLeft 6s 1.5s infinite;
}

.rocket {
  animation: flyToTop 6s 3s infinite;
}

@keyframes flyToLeft {
  0% {
    transform: translate(0, 0) scale(1, 1);
  }

  70% {
    transform: translate(0, 0) scale(1, 1);
  }

  80% {
    transform: translate(0, 0) scale(0.8, 1);
  }

  80.5% {
    transform: translate(0, 0) scale(1, 1);
  }

  100% {
    transform: translate(-340%, -50%) scale(0, 0);
  }
}

@keyframes flyToTop {
  0% {
    transform: translate(0, 0) scale(1, 1);
  }

  70% {
    transform: translate(0, 0) scale(1, 1);
  }

  80% {
    transform: translate(0, 0) scale(0.9, 0.8);
  }

  80.2% {
    transform: translate(0, 0) scale(1, 1);
  }

  100% {
    transform: translate(200%, -300%) scale(1, 1);
  }
}
</style>
<script>
import axios from "axios";
import { defineComponent, ref, computed, watch } from "vue";
import common from "../../utils/common";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import ui_botton_1 from "../ui/ui_btn_1.vue";
import ui_botton_3 from "../ui/ui_btn_3.vue";

export default defineComponent({
  name: "tools",
  props: {},
  components: {
    ui_botton_1,
    ui_botton_3,
  },
  setup(props, ctx) {
    let router = useRouter();
    let store = useStore();
    let cdnUrl = computed(() => {
      return store.state.cdnUrl;
    });
    // 获取系统配置信息
    // 获取IM下载链接
    /* 
    下载的type类型定义：
1 IM Win
2 IM Mac
3 Game Android
4 Game IOS
5 VPN Android
6 VPN IOS
7 VPN Win
8 VPN Mac
    */
    let imDownloadUrl = ref("");
    let imDownloadUrl_mac = ref("");
    const getIMDownloadUrl = () => {
      let sendUrl =
        // common.userApi.requestUrl + "/misc_api/app_download_url?type=1&domain="+location.hostname.replace('www.','');
        "https://statics.blockwar.io/hashtalk/debug/version_.json";
      if (common.isProduction) {
        sendUrl = "https://statics.blockwar.io/hashtalk/release/version_.json";
      }
      const sendHeaders = common.buildHeaders("from");
      axios
        .get(sendUrl, {
          headers: sendHeaders,
        })
        .then((r) => {
          console.log("--lb imDownloadUrl", r.data.window.download_url);
          // if (r.data.code == 0) {
          // imDownloadUrl.value = r.data.url;
          imDownloadUrl.value = r.data.window.download_url;
          imDownloadUrl_mac.value = r.data.mac.download_url;
          // }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally();
    };

    let apiReadyTag = computed(() => {
      return store.state.apiReadyTag;
    });
    if (apiReadyTag.value) {
      getIMDownloadUrl();
    }
    watch(apiReadyTag, (n, o) => {
      if (n) {
        getIMDownloadUrl();
      }
    });

    const openDownload = () => {
      if (imDownloadUrl.value) window.open(imDownloadUrl.value);
    };
    const toVpnPage = () => {
      common.reportRefereeUser();
      window.open("/vpn/home");
    };
    let lang = computed(() => {
      return store.state.lang;
    });
    let langTxt = store.state.text;

    // 上报推荐人
    const reportRefereeUser = () => {
      common.reportRefereeUser();
    };

    return {
      cdnUrl,
      langTxt,
      lang,
      openDownload,
      imDownloadUrl,
      imDownloadUrl_mac,
      toVpnPage,
      reportRefereeUser,
    };
  },
});
</script>
